import { IIconProps } from "@/components/icons/interface";

const HpPlusIcon = ({ width, height, color }: IIconProps) => {
  const fillColor = color ?? "white";
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M11.8739 3.01766C11.7016 3.06392 11.5555 3.21358 11.5147 3.38591C11.5029 3.4358 11.5011 3.9519 11.5011 7.47208V11.502H7.4721C3.91292 11.502 3.43582 11.5038 3.38412 11.5156C3.21088 11.5564 3.06122 11.7043 3.01587 11.8802C2.94784 12.1415 3.12017 12.4236 3.38503 12.4861C3.43491 12.4979 3.95101 12.4997 7.4721 12.4997H11.5011V16.5288C11.5011 20.0499 11.5029 20.566 11.5147 20.6158C11.5555 20.79 11.7025 20.9387 11.8785 20.985C12.1406 21.053 12.4227 20.8816 12.4853 20.6158C12.497 20.566 12.4989 20.0499 12.4989 16.5288V12.4997H16.5288C20.049 12.4997 20.5651 12.4979 20.615 12.4861C20.7891 12.4453 20.9379 12.2984 20.9841 12.1224C21.0521 11.8603 20.8807 11.5782 20.615 11.5156C20.5651 11.5038 20.049 11.502 16.5288 11.502H12.4989V7.47208C12.4989 3.9519 12.497 3.4358 12.4853 3.38591C12.4444 3.21176 12.2975 3.06301 12.1215 3.01675C12.0562 2.99952 11.9392 3.00043 11.8739 3.01766Z"
        fill={fillColor}
      />
    </svg>
  );
};

export { HpPlusIcon };
